class LeadersMasonry {
    constructor() {
        this.container = document.querySelector('.c-leaders_cont');
        this.items = Array.from(document.querySelectorAll('.c-leader_item'));
        this.columns = 3;
        
        this.init();
        this.bindEvents();
    }

    init() {
        this.determineColumns();
        this.createColumnStructure();
    }

    determineColumns() {
        if (window.innerWidth <= 768) {
            this.columns = 1;
        } else if (window.innerWidth <= 1200) {
            this.columns = 2;
        } else {
            this.columns = 3;
        }
    }

    createColumnStructure() {
        // Clear existing content
        this.container.innerHTML = '';
        
        // Create column wrappers
        const columnWrappers = Array.from({ length: this.columns }, () => {
            const column = document.createElement('div');
            column.className = 'leaders-column';
            return column;
        });

        // Distribute items horizontally (left to right)
        this.items.forEach((item, index) => {
            const columnIndex = index % this.columns;
            columnWrappers[columnIndex].appendChild(item);
        });

        // Append columns to container
        columnWrappers.forEach(column => {
            this.container.appendChild(column);
        });
    }

    destroy() {
        // No need for cleanup with this approach
    }

    bindEvents() {
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                const oldColumns = this.columns;
                this.determineColumns();
                
                // Only restructure if number of columns changed
                if (oldColumns !== this.columns) {
                    this.createColumnStructure();
                }
            }, 100);
        });
    }
}

export default LeadersMasonry;

// Initialize masonry layout
// document.addEventListener('DOMContentLoaded', () => {
//     const masonry = new LeadersMasonry();
// });
